export const BASE_OVERLAY_CLASS = 'fi-overlay-pane';
export const HIDDEN_UNDER_HEADER_OVERLAY = 'hidden-under-header-overlay';
